import { SET_AUTH } from "./type";

export const setAuth = (auth:any) => ({
  type: SET_AUTH,
  payload: auth,
});